import React, {useState} from 'react';
import ModalForm from '../Modals/ModalForm';

import { IconButton, Tooltip } from '@material-ui/core';
import { AddBox as AddBoxIcon } from '@material-ui/icons';

const Toolbar = (props) => {

    const [open, setOpen] = useState(false);
    const [schoolInfo, setSchoolInfo] = useState(null);

    const handleClick = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <IconButton aria-label="create" onClick={handleClick}>
                <Tooltip title="Create">
                    <AddBoxIcon />
                </Tooltip>
            </IconButton>

            <ModalForm
                open={open}
                handleClose={handleClose}
                fetchSchools={props.fetchSchools}
                selectedSchool={null}
            />
        </>
    );
}

export default Toolbar;